export enum ScorecardTabs {
  Timeline = 'Timeline',
  AINotes = 'AI Notes',
  Assistant = 'Assistant',
}
